import { atom } from 'recoil';

export const isClientsFilterModalOpenAtom = atom<boolean>({
  key: 'isClientsFilterModalOpenState',
  default: false,
});
